import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";

import Homepage4 from '../HomePage4'
import AboutPage from '../AboutPage'
import ServicePage from '../ServicePage';
import ServicePageS2 from '../ServicePageS2';
import ServiceSinglePage from '../ServiceSinglePage';
import ProjectPage from '../ProjectPage';
import ProjectPageS2 from '../ProjectPageS2';
import ProjectSinglePage from '../ProjectSinglePage';
import TeamSinglePage from '../TeamSinglePage';

import BlogPage from '../BlogPage'
// import BlogPageLeft from '../BlogPageLeft'
import BlogPageFullwidth from '../BlogPageFullwidth'
// import BlogDetails from '../BlogDetails'
 import BlogDetailsFull from '../BlogDetailsFull'
// import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide'
 
import TestimonialPage from '../TestimonialPage'
import ContactPage from '../ContactPage'
import ShopPage from '../ShopPage'
import OrderRecived from '../OrderRecived';
// import ProductSinglePage from '../ProductSinglePage';
// import CartPage from '../CartPage'
// import CheckoutPage from '../CheckoutPage'
import ErrorPage from '../ErrorPage'
import LoginPage from '../LoginPage'
import SignUpPage from '../SignUpPage'
import ForgotPassword from '../ForgotPassword'
import ProjectSinglePageArenover from '../riad-a-renover';
import Logo from '../../images/logo.svg'
import { FloatingWhatsApp } from 'react-floating-whatsapp'

const AllRoute = () => {


  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Homepage4/>} />
          <Route path='about' element={<AboutPage/>} />
          
          <Route path='service-single/:id' element={<ServiceSinglePage/>} />
          <Route path='team-single/:id' element={<TeamSinglePage/>} />
          <Route path='service' element={<ServicePage/>} />
          <Route path='service-s2' element={<ServicePageS2/>} />
          
          <Route path='riads-renove' element={<ProjectPage titre={"Riads Rénovés"}  />} />
          <Route path='riads-renove/:id' element={<ProjectSinglePage/>} />

          <Route path='riads-a-renover' element={<ProjectPage titre={"Riads à Rénover"}/>} />
          <Route path='riads-a-renover/:id' element={<ProjectSinglePageArenover/>} />

          {/* <Route path='project-s2' element={<ProjectPageS2/>} /> */}
          
          <Route path='temoignages' element={<TestimonialPage/>} />
          {/* <Route path='shop' element={<ShopPage/>} /> */}
          {/* <Route path='product-single/:id' element={<ProductSinglePage/>} /> */}
          {/* <Route path='cart' element={<CartPage/>} /> */}
          {/* <Route path='checkout' element={<CheckoutPage/>} /> */}
          {/* <Route path='order_received' element={<OrderRecived/>} /> */}
          <Route path='contact' element={<ContactPage/>} />
          <Route path='blog-fullwidth' element={<BlogPageFullwidth/>} /> 
          <Route path='page/:id' element={<BlogDetailsFull/>} />
          <Route path='*' element={<ErrorPage/>} />
        {/* <Route path='blog-single/:id' element={<BlogDetails/>} />
        <Route path='blog-single-left-sidebar/:id' element={<BlogDetailsLeftSiide/>} />
        <Route path='blog-single-fullwidth/:id' element={<BlogDetailsFull/>} />
        <Route path='blog' element={<BlogPage/>} />
        <Route path='blog-left-sidebar' element={<BlogPageLeft/>} />
       */}
       {/* <Route path='blog' element={<BlogPage/>} />
        <Route path='blog-fullwidth' element={<BlogPageFullwidth/>} /> 
          <Route path='login' element={<LoginPage/>} />
          <Route path='register' element={<SignUpPage/>} />
          <Route path='forgot-password' element={<ForgotPassword/>} /> */}
        </Routes>
        <FloatingWhatsApp
          phoneNumber="+212705749209" // e.g., +11234567890
          accountName="Get Riad"
          chatMessage=  "Salut! Comment pouvons-nous vous aider ?"
          avatar	={ Logo}
          statusMessage="Répond généralement sous 1 heure"
          message="Hello, I have a question!" // Optional: Custom message when the user opens the chat
          placeholder="Type a message"
          buttonStyle={{
            bottom: '20px',
            right: '20px',
            zIndex: 1000,
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default AllRoute;
